module.exports = __webpack_public_path__ + "static/media/signage-indoor-img43.b6c0d854.jpg";